(function () {
  var SUBSYSTEMS_SECTION_SUFFIX = '__166275878904455c58';
  var FEATURES_SECTION_SUFFIX = '__image_with_text_split_bjm44h';
  var PRODUCT_MAP = {
  "test-product": {
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M_UB_subs-01.jpg?v=1783285606",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M_UB_mobile_subs-02.jpg?v=1783285606",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M-UBproduct-01.jpg?v=1782927504"
    },
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M_TB_subs-01.jpg?v=1783286523",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M_TB_mobile_subs-02.jpg?v=1783286523",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411MTBproducts-01.jpg?v=1782942559"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M_SG_subs-01.jpg?v=1783286524",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M_SG_mobile_subs-02.jpg?v=1783286524",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M-SGproducts-01.jpg?v=1782929999"
    },
    "Essential Blue": {
      "subsDesktop": null,
      "subsMobile": null,
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411M-EBproduct-01.jpg?v=1782749274"
    }
  },
  "test-womens-calypso-v-neck-scrub-top-copy": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_TB_subs-01.jpg?v=1790006982",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_TB_mobile_subs-02.jpg?v=1790006982",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_TB_products-01.jpg?v=1786991999"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_UB_subs-01.jpg?v=1790006983",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_UB_mobile_subs-02.jpg?v=1790006983",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_UB_products-01.jpg?v=1786991997"
    },
    "Essential Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_EB_subs-01.jpg?v=1785945893",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_EB_mobile_subs-02.jpg?v=1785946324",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411WEBproducts-01.jpg?v=1785952492"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_SG_subs-01.jpg?v=1785945893",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_SG_mobile_subs-02.jpg?v=1785946323",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411WSGproducts-01.jpg?v=1785952492"
    }
  },
  "calypso-v-neck-top": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_TB_subs-01.jpg?v=1790006982",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_TB_mobile_subs-02.jpg?v=1790006982",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_TB_products-01.jpg?v=1786991999"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_UB_subs-01.jpg?v=1790006983",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_UB_mobile_subs-02.jpg?v=1790006983",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_UB_products-01.jpg?v=1786991997"
    },
    "Essential Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_EB_subs-01.jpg?v=1785945893",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_EB_mobile_subs-02.jpg?v=1785946324",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411WEBproducts-01.jpg?v=1785952492"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_SG_subs-01.jpg?v=1785945893",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411W_SG_mobile_subs-02.jpg?v=1785946323",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1411WSGproducts-01.jpg?v=1785952492"
    }
  },
  "amos-tech-cargo-scrub-pant": {
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247M_UB_Subsystems-01.jpg?v=1783187798",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247M_UB_mobile_subsystem-02.jpg?v=1783188013",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247M_UB_hero-01.jpg?v=1783269793"
    },
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247M_TB_subs-01.jpg?v=1783189129",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247M_TB_mobile_subs-02.jpg?v=1783189187",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247MTBbackpant.jpg?v=1773154794"
    },
    "Stealth Gray": {
      "subsDesktop": null,
      "subsMobile": null,
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247MSGproducts-01.jpg?v=1783025823"
    },
    "Essential Blue": {
      "subsDesktop": null,
      "subsMobile": null,
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247MEBprodcuts-01.jpg?v=1783025599"
    }
  },
  "test-bethany-polo": {
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423W_SG_subs-01.jpg?v=1783981299",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423W_SG_mobile_subs-02.jpg?v=1783981299",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423WSGproduct-01.jpg?v=1775581462"
    },
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423W_TB_subs-01.jpg?v=1783981299",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423W_TB_mobile_subs-02.jpg?v=1783981298",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423WTBproducts-01.jpg?v=1775580845"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423W_UB_subs-01.jpg?v=1783981297",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423W_UB_mobile_subs-02.jpg?v=1783981297",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1423WUBproduct-01.jpg?v=1775581659"
    }
  },
  "test-belle-pant": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248W_TB_subs-01.jpg?v=1783982328",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248W_TB_mobile_subs-02.jpg?v=1783982329",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248WTBproduct-01.jpg?v=1775597026"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248W_SG_subs-01.jpg?v=1783982329",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248W_SG_mobile_subs-02.jpg?v=1783982330",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248WSGproduct-01.jpg?v=1775663540"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248W_UB_subs-01.jpg?v=1783982324",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248W_UB_mobile_subs-02.jpg?v=1783982325",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248WUBproduct-01.jpg?v=1775597082"
    }
  },
  "test-althea-cargo": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247W_TB_subs-01.jpg?v=1783978517",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247W_TB_mobile_subs-02.jpg?v=1783978516",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247WTBproducts-01.jpg?v=1776269068"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247W_UB_subs-01.jpg?v=1783978518",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A247W_UB_mobile_subs-02.jpg?v=1783978517",
      "features": null
    }
  },
  "test-angelica-zip": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1412W_TB_subs-01.jpg?v=1783980248",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1412W_TB_mobile_subs-02.jpg?v=1783980249",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1412WTBproducts-01.jpg?v=1776270054"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1412W_UB_subs-01.jpg?v=1783980248",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1412W_UB_mobile_subs-02.jpg?v=1783980248",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1412WUBproducts-01.jpg?v=1776271367"
    }
  },
  "test-adelle-base-layer": {
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_UB_subs-01.jpg?v=1783983655",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_UB_mobile_subs-02.jpg?v=1783983801",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315WUBproduct-01.jpg?v=1779482968"
    },
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_TB_subs-01.jpg?v=1783983657",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_TB_mobile_subs-02.jpg?v=1783983656",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315WTBproduct-01.jpg?v=1779482375"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_SG_subs-01.jpg?v=1783983655",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_SG_mobile_subs-02.jpg?v=1783983655",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315WSGproduct-01.jpg?v=1779481734"
    },
    "Essential Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_EB_subs-01.jpg?v=1783983653",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_EB_mobile_subs-02.jpg?v=1783983656",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315WEBproducts-01.jpg?v=1779473761"
    },
    "High Viz Yellow": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_HVY_subs-01.jpg?v=1783983650",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315W_HVY_mobile_subs-02.jpg?v=1783983651",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315WHVYproduct-01.jpg?v=1779481096"
    }
  },
  "test_bateman-performance-polo-scrub-top": {
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412M_SG_subs-01.jpg?v=1783272416",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412M_SG_mobile_subs-02.jpg?v=1783272511",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412MSGproducts-01.jpg?v=1776097395"
    },
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412M_TB_subs-01.jpg?v=1783272993",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412M_TB_mobile_subs-02.jpg?v=1783272993",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412MTBproducts-01.jpg?v=1776093644"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412M_UB_subs-01.jpg?v=1783272993",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412M_UB_mobile_subs-02.jpg?v=1783273082",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1412MUBproducts-01.jpg?v=1776268814"
    }
  },
  "test_blackhawk-henley-scrub-top": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1413m_TB_subs-01.jpg?v=1783280294",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1413M_TB_mobile_subs-02.jpg?v=1783280295",
      "features": null
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1413M_SG_subs-01.jpg?v=1783280298",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1413M_SG_mobile_subs-02.jpg?v=1783280299",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1413M_SG_product-2-01.jpg?v=1776700850"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1413M_UB_subs-01.jpg?v=1783280290",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B1413M_UB_mobile_subs-02.jpg?v=1783280292",
      "features": null
    },
    "Essential Blue": {
      "subsDesktop": null,
      "subsMobile": null,
      "features": null
    }
  },
  "test_bristol-five-pocket-scrub-pant": {
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248M_SG_subs-01.jpg?v=1783271515",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248M_SG_mobile_subs-02.jpg?v=1783271515",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248MSGfrontview.jpg?v=1774456686"
    },
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248M_TB_subs-01.jpg?v=1783272159",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248M_TB_mobile_subs-02.jpg?v=1783272159",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248MTBfrontview.jpg?v=1774456685"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248M_UB_subs-01.jpg?v=1783271969",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248M_UB_mobile_subs-02.jpg?v=1783271969",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B248MUBbackview.jpg?v=1774456685"
    }
  },
  "test_albion-tech-mock": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1410M_TB_subs-01.jpg?v=1783270016",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1410M_TB_mobile_subs-02.jpg?v=1783270098",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1410M_TB-2-14_copy.jpg?v=1771253569"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1410M_UB_subs-01.jpg?v=1783270457",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1410M_UB_mobile_subs-02.jpg?v=1783270492",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1410M_UB_hollow_back-01_new.jpg?v=1772041193"
    }
  },
  "test_addison-1-2-sleeve-base-layer-top": {
    "High Viz Yellow": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315m_HVY_subs-01.jpg?v=1783359986",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_HVY_mobile_subs-02.jpg?v=1783359986",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_HVY_product-01.jpg?v=1779469975"
    },
    "Essential Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_EB_subs-01.jpg?v=1783358811",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_EB_mobile_subs-02.jpg?v=1783358811",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_EB_product-01.jpg?v=1779468650"
    },
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_TB_subs-01.jpg?v=1783359985",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_TB_mobile_subs-02.jpg?v=1783359985",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_TB_products-01.jpg?v=1779471313"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_SG_subs-01.jpg?v=1783359986",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_SG_mobile_subs-02.jpg?v=1783359986",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_SG_product-01.jpg?v=1779470677"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_UB_subs-01.jpg?v=1783359983",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_UB_mobile_subs-02.jpg?v=1783359983",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/A1315M_UB_products-01.jpg?v=1779471957"
    }
  },
  "test-womens-cynthia-mock-v-scrub-top": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_TB_subs-01.jpg?v=1790006605",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_TB_mobile_subs-02.jpg?v=1790006597",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410WTBproducts-01.jpg?v=1790006008"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_UB_subs-01.jpg?v=1790006605",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_UB_mobile_subs-02.jpg?v=1790006602",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410WUBproducts-01.jpg?v=1790006008"
    },
    "Essential Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_EB_subs-01.jpg?v=1790006603",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_EB_mobile_subs-02.jpg?v=1790006604",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410WEBproducts-02.jpg?v=1790006008"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_SG_subs-01.jpg?v=1790006604",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410W_SG_mobile_subs-02.jpg?v=1790006596",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C1410WSGproducts-01.jpg?v=1790006009"
    }
  },
  "test_chelsea-taper-scrub-pant": {
    "Triumph Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_TB_subs-01.jpg?v=1790005899",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_TB_mobile_subs-02.jpg?v=1790005897",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_TB_products-01.jpg?v=1790005551"
    },
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_SG_subs-01.jpg?v=1789056214",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_SG_mobile_subs-02.jpg?v=1789056214",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_SG_product-01.jpg?v=1789056213"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_UB_subs-01.jpg?v=1790005898",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_UB_mobile_subs-02.jpg?v=1790005899",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_UB_products-01.jpg?v=1790005549"
    },
    "Essential Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_EB_subs-01.jpg?v=1789056906",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419W_EB_mobile_subs-02.jpg?v=1789056905",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419WEBproducts-01.jpg?v=1788978449"
    }
  },
  "test_choptank-taper-scrub-pant-copy": {
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419M_SG_subs-01.jpg?v=1789059193",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419M_SG_mobile_subs-02.jpg?v=1789059192",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419MSGproducts-01.jpg?v=1790004272"
    },
    "Triumph Blue": {
      "subsDesktop": null,
      "subsMobile": null,
      "features": null
    },
    "Essential Blue": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419M_EB_subs-01.jpg?v=1790005362",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419M_EB_mobile_subs-02.jpg?v=1790005361",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/C2419M_EB_products-01.jpg?v=1790005074"
    },
    "Ultimate Black": {
      "subsDesktop": null,
      "subsMobile": null,
      "features": null
    }
  },
  "test_benhurst-1-4-zip-scrub-top": {
    "Stealth Gray": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B14A20M_SG_subs-01.jpg?v=1783283290",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B14A20M_SG_mobile_subs-02.jpg?v=1783283289",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B14A20MSGproduct-01.jpg?v=1776092549"
    },
    "Ultimate Black": {
      "subsDesktop": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B14A20M_UB_subs-01.jpg?v=1783283289",
      "subsMobile": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B14A20M_UB_mobile_subs-02.jpg?v=1783283289",
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B14A20MUBproducts-01.jpg?v=1776091997"
    },
    "Ultimate Black/Stealth Gray": {
      "features": "https://cdn.shopify.com/s/files/1/0639/7309/7725/files/B14A20MGBproducts-01.jpg?v=1776092610"
    }
  }
};

      function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?]+)/);
    return m ? m[1] : null;
  }

  function getSelectedColor() {
    var sel = document.querySelector('.product__color-swatch.selected[data-option-value]');
    return sel ? sel.getAttribute('data-option-value') : null;
  }

  function swapImg(img, url) {
    if (!img || !url) return;
    if (img.getAttribute('src') === url) return;
    img.setAttribute('src', url);
    img.setAttribute('srcset', url);
  }

  function applySubsystems(entry) {
    var section = document.querySelector('[id$="' + SUBSYSTEMS_SECTION_SUFFIX + '"]');
    if (!section) return;
    var mobileImgs = section.querySelectorAll('.image-hero__image--mobile img.image__img');
    var desktopImgs = section.querySelectorAll('.image-hero__image:not(.image-hero__image--mobile) img.image__img');
    mobileImgs.forEach(function (img) { swapImg(img, entry.subsMobile); });
    desktopImgs.forEach(function (img) { swapImg(img, entry.subsDesktop); });
  }

  function applyFeatures(entry) {
    var section = document.querySelector('[id$="' + FEATURES_SECTION_SUFFIX + '"]');
    if (!section) return;
    var imgs = section.querySelectorAll('.image-with-text-split__image-container img.image__img');
    imgs.forEach(function (img) { swapImg(img, entry.features); });
  }

  function applyColor(entryMap, color) {
    var entry = entryMap[color];
    if (!entry) return;
    applySubsystems(entry);
    applyFeatures(entry);
  }

  function sync() {
    var handle = currentHandle();
    var entryMap = handle ? PRODUCT_MAP[handle] : null;
    if (!entryMap) return;
    var color = getSelectedColor();
    if (color) applyColor(entryMap, color);
  }

  function init() {
    var handle = currentHandle();
    if (!handle || !PRODUCT_MAP[handle]) return;
    sync();
    var swatchEl = document.querySelector('.product__color-swatch[data-option-value]');
    var root = (swatchEl && (swatchEl.closest('product-form') || swatchEl.closest('form') || swatchEl.closest('.product__info-wrapper'))) || document.body;
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { sync(); }
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { sync(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
